/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { atom } from 'jotai'
import { atomFamily } from 'jotai/utils'

import { manualAtom, StoryblokActivityWithParentModule } from '@/store/manual'

/**
 * An atom family that finds a specific activity and its parent module within the manual data, using the Storyblok UUID
 * assigned to the activity story. Useful for when you have a reference UUID for an activity.
 */
export const findActivityAndModuleByActivityStoryblokId = atomFamily((identifier: string) =>
  atom<StoryblokActivityWithParentModule | null>((get) => {
    const manual = get(manualAtom)

    if (!manual || !('modules' in manual)) {
      return null
    }

    for (const moduleItem of manual.modules) {
      const activityItem = moduleItem.activities.find((activity) => activity.activity.uuid === identifier)

      if (activityItem) {
        return {
          module: moduleItem.module,
          activity: activityItem.activity,
        }
      }
    }

    return null
  }),
)
